$(function ($) {
  var $ = $; // keep this ref local
  var QUOTE_CHECK_TIMEOUT = 1250;

  // [EDIT] 20230606 Shane update - Add GRFQApp custom add function to implement the functionality of getting quote item number
  function showQuoteIndicator() {
    var quoteIndicatorEl = document
      .querySelector("#quote-icon")
      .querySelector(".indicator");
    quoteIndicatorEl.style.display = "flex";
    quoteIndicatorEl.style.opacity = 100;
    quoteIndicatorEl.style.transform = "scale(1)";
  }

  function hideQuoteIndicator() {
    document
      .querySelector("#quote-icon")
      .querySelector(".indicator").style.display = "none";
  }

  function checkQuoteItem() {
    var quoteItems = localStorage.getItem("quoteItem");
    if (
      (GRFQApp.popup &&
        GRFQApp.popup.quoteItems &&
        GRFQApp.popup.quoteItems.length > 0) ||
      (typeof quoteItems !== "undefined" && +quoteItems !== 0)
    ) {
      showQuoteIndicator();
      if (!GRFQApp.popup || !GRFQApp.popup.quoteItems) return;
      localStorage.setItem("quoteItem", GRFQApp.popup.quoteItems.length);
    } else {
      hideQuoteIndicator();
    }
  }

  function increaseQuoteItem() {
    var originalQuoteItem = localStorage.getItem("quoteItem");
    localStorage.setItem(
      "quoteItem",
      typeof originalQuoteItem !== "undefined" ? +originalQuoteItem + 1 : 1
    );
    showQuoteIndicator();
  }

  function decreaseQuoteItem() {
    var originalQuoteItem = localStorage.getItem("quoteItem");
    var newQuoteItem =
      typeof originalQuoteItem !== "undefined" && +originalQuoteItem > 0
        ? +originalQuoteItem - 1
        : 0;
    localStorage.setItem("quoteItem", newQuoteItem);
    if (newQuoteItem > 0) return;
    hideQuoteIndicator();
  }

  function customQuoteRemoveItem() {
    GRFQApp.popup.removeItem(arguments[0]); // This is an async function sho we should wait for it.
    decreaseQuoteItem();
    setTimeout(function () {
      setCustomRemoveOnclick();
    }, QUOTE_CHECK_TIMEOUT);
  }

  function setCustomRemoveOnclick() {
    $(".grfq__popupForm__itemActionDelete").each(function (_, el) {
      $(el).on("click", customQuoteRemoveItem);
    });
  }

  checkQuoteItem();

  console.log("[checkpoint] for the custom GRFQApp");
  GRFQApp.customOpenQuotePopup = function () {
    console.log('GRFQApp should be open')
    GRFQApp.openQuotePopup(); // This is an async function we should wait for it.
    setTimeout(function () {
      checkQuoteItem();
      setCustomRemoveOnclick();
    }, QUOTE_CHECK_TIMEOUT);
  };
  console.log("[checkpoint] GRFQApp should have a customOpenQuotePopup function: ", GRFQApp.customOpenQuotePopup)

  GRFQApp.customAdd = function () {
    console.log('target product: ', arguments[1], {GRFQCollection});
    GRFQApp.add(arguments[0], arguments[1]); // This will trigger the openQuotePopup which is an async function, so we should wait for it.
    increaseQuoteItem();
    setTimeout(function () {
      // GRFQApp.openQuotePopup();
      checkQuoteItem();
      setCustomRemoveOnclick();
    }, QUOTE_CHECK_TIMEOUT);
  };

});
